import React from 'react';

const BarsIcon = ({ size = 33, ...props }) => (
  <svg
    width={Math.round((size * 32) / 22)}
    height={size}
    viewBox='0 0 32 22'
    fill='currentColor'
    {...props}>
    <path d='M31.8897 5.25761L29.1459 18.4054H26.5468L28.7422 7.88642H26.1412L23.9459 18.4054H26.5468L25.9984 21.0342H20.7984L24.0905 5.25761H31.8897ZM5.34473 7.88642L4.79635 10.5171H7.39545L5.74844 18.4054H3.14934L4.79635 10.5171H2.19541L3.24659e-06 21.0342H7.79915L10.5429 7.88642H5.34473ZM22.5882 0L18.1992 21.0342H10.4001L14.7891 0H22.5882ZM19.4407 2.62881H16.8398L13.5476 18.4054H16.1467L19.4407 2.62881Z' />
  </svg>
);

export default BarsIcon;
